export default __webpack_public_path__ + "static/media/Hair_12_M_C2.e9d5fa55.svg";